import { Link } from "react-router-dom";
import { APP_PATHS } from "../../../constants/paths";
import PrimaryButton from "../../UI/PrimaryButton/PrimaryButton";
import classNames from "classnames";
import emptyCart from "../../../assets/icons/empty_cart.svg";
import classes from "./EmptyCart.module.css";

const EmptyCart = () => {
  return (
    <div className={classNames("mx-auto text-center", classes["empty-cart"])}>
      <img
        src={emptyCart}
        alt="empty cart"
        className={classNames("mx-auto", classes["empty-cart__svg"])}
      />
      <h2 className={classes["empty-cart__title"]}>لا يوجد منتجات في العربة</h2>
      <p className={classes["empty-cart__description"]}>
        اضف منتجات في عربة التسوق و استمتع بالبونص الاسبوعي
      </p>

      <PrimaryButton role="link" className={classes["empty-cart__primary-btn"]}>
        <Link
          to={APP_PATHS.HOME.url}
          className={classNames(
            "block w-full",
            classes["empty-cart__shopping-link"]
          )}
        >
          تسوق الان
        </Link>
      </PrimaryButton>
    </div>
  );
};

export default EmptyCart;
